module.exports = __webpack_public_path__ + "img/online-content.36f28938.png";